import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26233b73"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-content-between gap-2" }
const _hoisted_2 = { class: "p-input-icon-left float-right" }
const _hoisted_3 = ["innerHTML"]

import { Doctor } from '@/interfaces/Doctor';
import { ref, PropType, watch, computed } from 'vue';
import { useRouter } from 'vue-router';

import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import Tag from 'primevue/tag';
import Avatar from 'primevue/avatar';
import { DateUtils } from '@/utils/DateUtils';
import { useListFilters } from '@/stores/listFilters';


export default /*#__PURE__*/_defineComponent({
  __name: 'DoctorList',
  props: {
  doctors: {
    type: Array as PropType<Doctor[]>,
    default: () => []
  },
  tabOnClick: {
    type: String,
    default: null
  },
  refId: {
    type: String,
    default: null
  }
},
  setup(__props) {

const props = __props;

const router = useRouter();
const listFilters = useListFilters();

const filteredDoctors = ref<Doctor[]>([...props.doctors]);
const rowsPerPage = ref(listFilters.doctorRows);

const onPage = (event: any) => {
  listFilters.setDoctorRows(event.rows);
};

const searchQuery = ref(listFilters.doctorFilter);

const safeDisplay = (value: string): string => value || '';

const clearFilter = () => {
  searchQuery.value = '';
  listFilters.clearDoctorFilter();
  filteredDoctors.value = [...props.doctors];
};

const searchData = () => {
  const query = searchQuery.value?.toLowerCase() || '';
  listFilters.setDoctorFilter(searchQuery.value ?? '');
  filteredDoctors.value = props.doctors.filter((doctor) => {
    const fullName = `${doctor.firstName ?? ''} ${doctor.lastName ?? ''}`.toLowerCase();
    return (
      doctor.phoneNo?.toLowerCase().includes(query) ||
      fullName.includes(query) ||
      doctor.email?.toLowerCase().includes(query) ||
      doctor.specialization?.toLowerCase().includes(query)
    );
  });
};

const onSelectedRow = (event: any) => {
  if (event.data.status == 0) {
    //alert('Acest utilizator a fost sters');
  } else {
    if(props.tabOnClick != null) {
      router.push({ 
        name: 'patient-details', 
        ...(props.refId ? { query: { refId: event.data.id } } : {})
      });
    } else {
      const selectedDoctorId = event.data.id;
      router.push({ 
        name: 'doctor-details', 
        params: { id: selectedDoctorId },
        ...(props.refId ? { query: { refId: props.refId } } : {})
      });
    }
  }
};

watch(
  () => props.doctors,
  (newValue) => {
    filteredDoctors.value = [...newValue];
    searchData();
  },
  { immediate: true }
);

const computedDoctors = computed(() => {
  return filteredDoctors.value.map(d => ({
    ...d,
    sortName: `${d.title ?? ''} ${d.firstName ?? ''} ${d.lastName ?? ''}`.toLowerCase(),
    sortCreatedAt: d.createdAt ? new Date(d.createdAt).getTime() : 0
  }));
});


return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(DataTable), {
      value: computedDoctors.value,
      sortField: "sortCreatedAt",
      sortOrder: -1,
      onRowSelect: onSelectedRow,
      onPage: onPage,
      selectionMode: "single",
      stripedRows: "",
      paginator: "",
      rows: rowsPerPage.value,
      rowsPerPageOptions: [5, 10, 20, 50]
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_unref(Button), {
            type: "button",
            class: "p-button-sm",
            icon: "pi pi-filter-slash",
            outlined: "",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (clearFilter()))
          }),
          _createElementVNode("span", _hoisted_2, [
            _createVNode(_unref(IconField), null, {
              default: _withCtx(() => [
                _createVNode(_unref(InputIcon), { class: "pi pi-search" }),
                _createVNode(_component_InputText, {
                  class: "md:w-auto w-10rem",
                  onInput: searchData,
                  modelValue: searchQuery.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchQuery).value = $event)),
                  placeholder: "Caută.."
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(Column), { header: "" }, {
          body: _withCtx(({ data }) => [
            _createVNode(_unref(Avatar), {
              image: data.photoUrl,
              icon: data.photoUrl ? undefined : 'pi pi-user',
              shape: "circle",
              size: "normal"
            }, null, 8, ["image", "icon"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          header: "Nume",
          field: "sortName",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", {
              innerHTML: 
              (data.status == 0
                ? '<i class=\'pi pi-times disabledrow\'></i> '
                : ' ') +
              safeDisplay(data.title) +
              ' ' +
              safeDisplay(data.firstName) +
              ' ' +
              safeDisplay(data.lastName)
            
            }, null, 8, _hoisted_3)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "phoneNo",
          header: "Telefon"
        }),
        _createVNode(_unref(Column), {
          field: "email",
          header: "Email",
          style: {"width":"100px"}
        }),
        _createVNode(_unref(Column), {
          field: "specialization",
          header: "Specializare",
          sortable: ""
        }),
        _createVNode(_unref(Column), {
          header: "Inregistrat",
          field: "sortCreatedAt",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(_unref(DateUtils).format(data.createdAt)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          header: "Număr pacienți",
          field: "patientsCount",
          sortable: ""
        }),
        _createVNode(_unref(Column), { header: "Activ" }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", null, [
              (data.status != 0)
                ? _withDirectives((_openBlock(), _createBlock(_unref(Tag), {
                    key: 0,
                    severity: data.status == 1 ? 'success' : 'warning',
                    icon: 
                data.status === true
                  ? 'pi pi-check-circle'
                  : 'pi pi-times-circle'
              ,
                    value: data.status == 1 ? 'Da' : 'Nu'
                  }, null, 8, ["severity", "icon", "value"])), [
                    [
                      _directive_tooltip,
                      {
                value: data.status == 1 ? 'Cont activ' : 'Cont suspendat',
                showDelay: 100,
                hideDelay: 300
              },
                      void 0,
                      { left: true }
                    ]
                  ])
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "rows"])
  ]))
}
}

})